import React from "react"
import { Elements } from "react-stripe-elements"
import CheckoutForm from "./checkout-form"
import glamorous from "glamorous"
import style from "utils/style"

class Checkout extends React.Component {
  render() {
    return (
      <Container>
        <Elements>
          <CheckoutForm />
        </Elements>
      </Container>
    )
  }
}

export default Checkout

const Container = glamorous.div({
  width: "40rem",
  margin: "3rem auto",
  padding: "2rem",
  border: "1px solid black",
  [style.size.mobile]: {
    width: "100%",
  },
})



// WEBPACK FOOTER //
// ./src/scenes/Camp/CampBilling/checkout.js